import { http } from '@/http';

export const initiateKYC = async (ulid: string, client_id: string) =>
	(await http.post)<{ kyc_url: string }>(`v2/onboarding/${ulid}/init-kyc`, {
		client_id,
	});
